import React, { useState } from "react";
import { api } from "../api";
import { useUI } from "../components/UI";

export default function Login({ onLogin }) {
  const { run } = useUI();
  const [password, setPassword] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    const data = await run(async () => (await api.post("/auth/login", { password })).data);
    if (data?.token) onLogin(data.token);
  };

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <img className="login-logo" src={`${process.env.PUBLIC_URL}/instamatch_logo.svg?v=3`} alt="" />
        <h2>instamatch</h2>
        <p className="muted">Sign in to continue.</p>
        <input
          type="password"
          placeholder="Password"
          value={password}
          autoFocus
          onChange={(e) => setPassword(e.target.value)}
        />
        <button className="btn primary" type="submit" disabled={!password}>Sign in</button>
      </form>
    </div>
  );
}
